import React from "react";
import {Box, Typography} from "@mui/material";
import type {Opportunity} from "../opportunityIntelligenceDemoData";
import {formatCompactCurrency, groupByStage, STAGE_LABEL, stageAccent} from "../opportunityUtils";
import {IdentifiedCell, SitBadge, SourceChip} from "./OpportunityCells";

type Props = { rows: Opportunity[] };

const LifecycleCard: React.FC<{ opp: Opportunity }> = ({opp}) => (
    <Box className="oi-lc-card">
        <Typography className="oi-lc-card-title">{opp.title}</Typography>
        <Typography className="oi-lc-card-summary">{opp.summary}</Typography>
        <SitBadge opp={opp}/>
        <Box className="oi-lc-card-footer">
            <SourceChip source={opp.source}/>
            <IdentifiedCell opp={opp}/>
        </Box>
    </Box>
);

export const LifecycleView: React.FC<Props> = ({rows}) => {
    const columns = React.useMemo(() => groupByStage(rows), [rows]);

    return (
        <Box className="oi-lifecycle">
            {columns.map(col => {
                const currency = col.items[0]?.currency ?? 'EUR';
                return (
                    <Box key={col.stage} className="oi-lc-column" style={{borderTopColor: stageAccent(col.stage)}}>
                        <Box className="oi-lc-column-header">
                            <span className="oi-lc-column-name">{STAGE_LABEL[col.stage]}</span>
                            <span className="oi-lc-column-count">{col.items.length}</span>
                            <span className="oi-lc-column-total">{formatCompactCurrency(col.total, currency)}</span>
                        </Box>
                        <Box className="oi-lc-column-body">
                            {col.items.map(opp => <LifecycleCard key={opp.id} opp={opp}/>)}
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
};
